module.exports = __webpack_public_path__ + "img/Tim Wadsworth.aa20e7fc.jpg";